module.exports = __webpack_public_path__ + "img/openfirehydrant_attached.c4ecbbf5.svg";